module.exports = __webpack_public_path__ + "img/layout_tree_left_right_icon.a02f20f2.svg";